import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToCreateEventSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const createEventSteps: StepType[] = [
    {
      content: 'Go to the Calendar menu tab',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.MENU}"]`,
      position: 'right',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      disableActions: true,
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
    },
    {
      content: 'Then select Calendar to view the Calendar view page.',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 200);
          },
          false,
        );
      },
      disableActions: false,
      styles: {
        arrow: (base) => ({
          ...base,
        }),
      },
    },
    {
      content: 'Click the Create Event Button.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.CREATE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 200);
            // setIsOpen(false);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          content={
            // eslint-disable-next-line max-len
            'Enter the event details like the event title, event type, time and date, guest, description, and notification.'
          }
          type="create event"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="Modal__Header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.FORM}"]`,
      ],
      disableActions: false,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 100);
          },
          false,
        );
      },
      stepInteraction: false,
      position: 'left',
    },
    {
      content: 'Click Save, and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
    },
  ];

  const showCreateEventSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(createEventSteps);
      setIsOpen(true);
    }, 300);
  };

  return showCreateEventSteps;
};

export default useGetHowToCreateEventSteps;
